export default "__VITE_ASSET__kRAfSBmP__"